// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"a5629ed8","1576":"4a4c4488","2429":"a5629ed8","6534":"ce99d352"}[chunkId] + ".chunk.css";
};